import axios from 'axios'
import MockAdapter from 'axios-mock-adapter'

const mockAxios = axios.create()
const mock = new MockAdapter(mockAxios)

export { mock, mockAxios }
